"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _Count = _interopRequireDefault(require("../../Common/Count"));
var _Name = _interopRequireDefault(require("../Name"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _excluded = ["managers", "value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX;
var PLACEHOLDER = 'Выбрать ответственного';
var defaultProps = {
  className: '',
  managers: null,
  onChange: function onChange() {
    return null;
  },
  value: null
};
var ManagerSelector = /*#__PURE__*/function (_React$PureComponent) {
  function ManagerSelector(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ManagerSelector);
    _this = _callSuper(this, ManagerSelector, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ManagerSelector, _React$PureComponent);
  return (0, _createClass2["default"])(ManagerSelector, [{
    key: "handleChange",
    value: function handleChange(selected) {
      var onChange = this.props.onChange;
      var value = (selected === null || selected === void 0 ? void 0 : selected.value) || '';
      onChange({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        managers = _this$props.managers,
        value = _this$props.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      if ((0, _isEmpty2["default"])(managers)) {
        return null;
      }
      var selectedManager = (0, _find2["default"])(managers, {
        value: value
      }) || null;
      return /*#__PURE__*/_react["default"].createElement(StyledSelector, (0, _extends2["default"])({}, props, {
        components: {
          SingleValue: ManagerSelector.getValueLabel
        },
        isSearchable: true,
        isClearable: true,
        onChange: this.handleChange,
        filterOption: ManagerSelector.customFilter,
        options: managers,
        placeholder: PLACEHOLDER,
        value: selectedManager
      }), function (_ref) {
        var data = _ref.data;
        var avatarUrl = data.avatarUrl,
          name = data.name,
          unreadAmount = data.unreadAmount;
        var isValidCount = (0, _isInteger2["default"])(unreadAmount) && unreadAmount > 0;
        return /*#__PURE__*/_react["default"].createElement(StyledOption, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
          name: name,
          url: avatarUrl
        }), name && /*#__PURE__*/_react["default"].createElement(StyledName, {
          name: name
        }), isValidCount && /*#__PURE__*/_react["default"].createElement(StyledCount, {
          value: unreadAmount
        }));
      });
    }
  }], [{
    key: "getValueLabel",
    value: function getValueLabel(prop) {
      var data = prop.data,
        innerProps = prop.innerProps;
      var avatarUrl = data.avatarUrl,
        name = data.name;
      return /*#__PURE__*/_react["default"].createElement(StyledValue, innerProps, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: name,
        url: avatarUrl
      }), /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: name
      }));
    }
  }, {
    key: "customFilter",
    value: function customFilter(_ref2, searchText) {
      var data = _ref2.data;
      var name = data.name;
      var formattedName = name && name.toLowerCase() || '';
      var formattedQuery = searchText && searchText.toLowerCase();
      var isMatched = formattedName.includes(formattedQuery);
      return isMatched;
    }
  }]);
}(_react["default"].PureComponent);
ManagerSelector.defaultProps = defaultProps;
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "ManagerSelector__StyledAvatar",
  componentId: "sc-hkot74-0"
})([""]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "ManagerSelector__StyledName",
  componentId: "sc-hkot74-1"
})(["font-size:14px;font-weight:300;"]);
var StyledCount = (0, _styledComponents["default"])(_Count["default"]).withConfig({
  displayName: "ManagerSelector__StyledCount",
  componentId: "sc-hkot74-2"
})(["margin-left:auto;"]);
var StyledMangerBase = _styledComponents["default"].div.withConfig({
  displayName: "ManagerSelector__StyledMangerBase",
  componentId: "sc-hkot74-3"
})(["align-items:center;display:flex;"]);
var StyledOption = (0, _styledComponents["default"])(StyledMangerBase).withConfig({
  displayName: "ManagerSelector__StyledOption",
  componentId: "sc-hkot74-4"
})(["align-items:center;display:flex;", "{height:26px;width:26px;}", "{color:#4d4d4d;margin-left:10px;}"], StyledAvatar, StyledName);
var StyledValue = (0, _styledComponents["default"])(StyledMangerBase).withConfig({
  displayName: "ManagerSelector__StyledValue",
  componentId: "sc-hkot74-5"
})(["", "{height:18px;width:18px;}", "{margin-left:6px;}"], StyledAvatar, StyledName);
var StyledSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "ManagerSelector__StyledSelector",
  componentId: "sc-hkot74-6"
})([".", "__multi-value__label{padding-left:4px !important;}"], CLASS_NAME_PREFIX);
var _default = exports["default"] = ManagerSelector;